const FormWrapper = ({ children }) => {
  return (
    <div className="md:w-1/3 w-full flex bg-[#fff] h-full -md:mb-12">
      <div className="w-full flex justify-center items-center flex-col">{children}</div>
    </div>
  );
};

export default FormWrapper;
